module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBigBlack.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBigBlack.png
// module id = 248
// module chunks = 0